import { Component } from '@angular/core';
import { CardKpiDetailsComponent } from 'app/components/card-kpi-details/card-kpi-details.component';

@Component({
  selector: 'app-page-kpi-details',
  imports: [CardKpiDetailsComponent],
  templateUrl: './page-kpi-details.component.html',
  styleUrl: './page-kpi-details.component.scss',
})
export class PageKpiDetailsComponent {}
